import { render } from "./ActiveFilterList.vue?vue&type=template&id=e47a0a24&scoped=true"
import script from "./ActiveFilterList.vue?vue&type=script&lang=js"
export * from "./ActiveFilterList.vue?vue&type=script&lang=js"

import "./ActiveFilterList.vue?vue&type=style&index=0&id=e47a0a24&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47a0a24"]])

export default __exports__